// stores
import * as ProtocolsStore from '../../../redux/middleware/MedicalProtocolMiddleware';
import * as ProtocolConsumptionStore from '../../../redux/middleware/ProtocolConsumptionMiddleware';
import * as PractitionersStore from '../../../redux/middleware/PractitionerMiddleware';

// state
import { AppState } from '../../../redux/reducers';
import { Protocol } from '../../../models/Entities/Protocols/Protocol';
import { ProtocolPatient } from '../../../models/Entities/Protocols/ProtocolPatient';
import { ProtocolConsumption } from '../../../models/Entities/Protocols/ProtocolConsumption';
import { Practitioner } from '../../../models/Entities/Practitioners/Practitioner';

//#region Props

interface IProps {
    ProtocolId: number;
    onSelectionChange?: (consumptions: ProtocolConsumption[]) => void;
    showGroupedByVisit?: boolean;
    ProviderId?: number;
    StageId?: number;
    GetProtocolById?: (id: number) => any;
    onDeleteConsumption?: (consumption: ProtocolConsumption) => void;
}

interface ConnectedProps {
    protocol: Protocol | null;
    patients: ProtocolPatient[];
    isLoadingPatients: boolean;
    consumptionsByPatient: { [numberInProtocol: string]: ProtocolConsumption[] };
    patientConsumptionsLoading: { [numberInProtocol: string]: boolean };
    GetPersonByIdentifier: (identifier: string) => Practitioner | undefined;
}

interface DispatchProps {
    GetAllProtocolConsumptionsByPatient: typeof ProtocolConsumptionStore.ActionCreators.GetAllProtocolConsumptionsByPatient;
    GetAllPractitioners: typeof PractitionersStore.actionCreators.GetAllPractitioners;
    GetMedicalProtocolById: typeof ProtocolsStore.actionCreators.GetMedicalProtocolById;
    GetProtocolPatients: typeof ProtocolsStore.actionCreators.GetProtocolPatients;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {
    const practitioners = state.Practitioners?.list || [];

    const protocol: Protocol | null =
        state.MedicalProtocols?.list?.find((p: Protocol) => p.id === ownProps.ProtocolId) ?? null;

    const GetPersonByIdentifier = (identifier: string): Practitioner | undefined =>
        practitioners.find((p: Practitioner) => p.userId === identifier);

    return {
        protocol,
        patients: protocol?.patients ?? [],
        isLoadingPatients: state.MedicalProtocols?.isLoadingProtocolPatients ?? false,
        consumptionsByPatient: protocol?.consumptionsByPatient ?? {},
        patientConsumptionsLoading: protocol?.patientConsumptionsLoading ?? {},
        GetPersonByIdentifier,
    };
};

export const mapDispatchToProps = {
    ...ProtocolConsumptionStore.ActionCreators,
    ...PractitionersStore.actionCreators,
    ...ProtocolsStore.actionCreators,
};

export const GetStatusDescription = (status: number): { description: string; class: string } => {
    switch (status) {
        case 0: return { description: 'Pendiente de liquidación', class: 'status-not-settled' };
        case 1: return { description: 'Con saldo pendiente', class: 'status-pending' };
        case 2: return { description: 'Pagado', class: 'status-payee' };
        case 3: return { description: 'Liquidado', class: 'status-settled' };
        case 4: return { description: 'Rechazado', class: 'status-rejected' };
        case 5: return { description: 'Ignorado', class: 'status-ignored' };
        case 6: return { description: 'A liquidar', class: 'status-to-settle' };
        case 7: return { description: 'Facturado', class: 'status-invoiced' };
        case 8: return { description: 'Parcialmente liquidado', class: 'status-partial-settled' };
        default: return { description: 'Desconocido', class: 'status-unknown' };
    }
};
